import React from 'react';

interface OpportunitiesCardFooterProps {
	footerText: string;
	floor?: string;
	room?: string;
}

const OpportunitiesCardFooter: React.FC<OpportunitiesCardFooterProps> = ({ footerText, room, floor }) => {
	return (
		<div className="py-2 px-4 bg-[#EBEBF0] dark:bg-[#EBEBF0] flex items-center border-t border-[#E4E4EB] dark:border-0 rounded-b-[12px] text-[#28293D] text-[14px] font-[400] leading-[20px]">
			{room && floor ? footerText : 'Room and Floor is not assigned'}
		</div>
	);
};

export default OpportunitiesCardFooter;
